import RepeatReferralDetailsContainer from './repeat-referral-details-container';

export default RepeatReferralDetailsContainer;
